import { SessionStatus } from '@sunrise-ui/api/events/api';
import { useMemo } from 'react';
import { useGetSessionsByEventId } from '../queries/sessions';

/**
 * Hook to check if an event has any sessions in voting status
 */
export const useEventHasVotingSessions = (eventId?: string) => {
  const { data: sessions, isLoading } = useGetSessionsByEventId(eventId);

  const hasVotingSessions = useMemo(() => {
    if (!sessions) return false;
    return sessions.some((session) => session.status === SessionStatus.Voting);
  }, [sessions]);

  return {
    hasVotingSessions,
    isLoading,
  };
};
